<template lang="html">

   <section class="header"  >
    <div class="animated slideInLeft" >
      <div class="container row-center">
        <router-link class="logo" to="/" ></router-link>
        <button :class="['icon-menu', show_menu ? 'active' : '']" @click="toggleMenu" class="menu column-center" >
           <div class="menu-toggle first">
              <i></i>
            </div>
          MENU
        </button>
        <div class="logo"><p>MW</p></div>
      </div>

    </div>

    <nav :class="['overlay-menu', show_menu ? 'open' : '']">
     
      <div class="enlaces ">
        <router-link to="/">HOME</router-link>
        <router-link to="/about">ABOUT</router-link>
        <router-link to="/my-space">MY SPACE</router-link>
        <router-link to="/my-workout">MY WORKOUT</router-link>
        <router-link to="/philosphy">MY PHILOSOPHY </router-link>
        <router-link to="/#contact">CONTACT </router-link>
        <router-link to="/faqs">FAQs </router-link>
         <a
              class="rrss d-flex"
              href="https://www.instagram.com/jcmyworkout/?hl=es"
              target="_blank"
            >
              SÍGUENOS
              <img src="/static/img/instagram.svg" alt="">
            </a>
      </div>
      
      </div>
    </nav>
   
  </section>

</template>

<script lang="js">

  export default {
    name: 'app-header',
     components: {
    },
    props: [],
    data() {
      return {
        show_menu: false

      }
    },
    methods: {
      toggleMenu: function () {
        this.show_menu = !this.show_menu;
      }
    },
    computed: {
     
    },
    watch: {
      '$route': function () {
            this.show_menu = false;
      }

   }
  }
</script>

<style lang="scss">
.header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background: transparent;
  border-right: 1px solid black;
  width: 80px;
  right: 0;
  bottom: 0;
  height: 100vh;
  @media screen and (max-width: 1024px) {
    border-right: 0;
  }
  @media screen and(max-width:1300px) {
    border-right: 0;
  }
  @media screen and (max-width: 600px) {
    width: 60px;
  }
  .logo {
    background: #ffffffd6;
    width: 100%;
    p {
      font-family: "GothamBold";
      font-size: 28px;
      text-align: center;
      padding: 5px 0;
      border-bottom: 1px solid black;
      @media screen and(max-width:1300px) {
        border-bottom: 0;
      }
      @media screen and(max-width:600px) {
        font-size: 20px;
        padding: 0 0 5px 0;
      }
    }
  }
  .menu {
    font-family: "GothamBold";
    font-size: 16px;
    background: #ffffffd6;
    border: 0;
    width: 100%;
    border-bottom: 1px solid black;
    padding: 20px 0 10px 0;
    cursor: pointer;
    @media screen and (max-width: 1024px) {
      border-bottom: 0;
    }
    @media screen and(max-width:1300px) {
      border-bottom: 0;
    }
    @media screen and (max-width: 600px) {
      padding: 10px;
      font-size: 10px;
    }

    .menu-toggle {
      height: 32px;
      position: relative;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: 0.5s ease-in-out;
      -moz-transition: 0.5s ease-in-out;
      -o-transition: 0.5s ease-in-out;
      transition: 0.5s ease-in-out;
      cursor: pointer;
      width: 40px;
      margin-bottom: 20px;
      @media screen and (max-width: 600px) {
        margin-bottom: 5px;
      }
    }

    .menu-toggle:hover {
      color: #999;
    }
    .menu-toggle i,
    .menu-toggle i:after,
    .menu-toggle i:before {
      display: block;
      position: absolute;
      height: 1px;
      width: 40px;
      right: 0;
      background: black;
      border-radius: 2px;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: 0.25s ease-in-out;
      -moz-transition: 0.25s ease-in-out;
      -o-transition: 0.25s ease-in-out;
      transition: 0.25s ease-in-out;
    }
    .menu-toggle i:after,
    .menu-toggle i:before {
      content: "";
    }
    .menu-toggle i:after {
      top: -32px;
    }
    .menu-toggle i:before {
      top: -16px;
    }
    .menu-toggle i {
      top: 32px;
    }
  }
  .icon-menu.active {
    .menu-toggle i:after {
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
      top: -22px;
    }
    .menu-toggle i:before {
      -webkit-transform: rotate(-45deg);
      -moz-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      transform: rotate(-45deg);
      top: -22px;
    }
  }
  .overlay-menu {
    // width: 35vw;
    height: 0%;
    min-height: 100vh;
    background-color: rgba(234, 229, 220, 0.9);
    position: absolute;
    left: -100vw;
    z-index: 200;
    overflow: hidden;
    will-change: transform, opacity;
    -webkit-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
    top: 0;
    bottom: 0;
    padding: 0 5vw 0 10vw;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    .enlaces {
      display: flex;
      flex-direction: column;
      .rrss{
        align-items: center;
        margin-top: 25px;
        border-top: 1px solid;
        padding-top: 25px;
        font-size:40px;
        img{
          max-height: 50px;
          margin-left: 25px;
           @media screen and (max-width: 1024px) {
           max-height: 30px;
          }
           @media screen and (max-width: 600px) {
             max-height: 20px;
          }
         }
          
          @media screen and (max-width: 1024px) {
            font-size: 30px;
          }
          @media screen and (max-width: 800px) {
           font-size: 25px;
          }
          @media screen and (max-width: 600px) {
           font-size: 18px;
          }
         
      }
      a {
        color: black;
        font-family: "GothamBold";
        font-size: 4vw;
        text-align: left;
        opacity: 0.5;
        margin-bottom: 5px;
        @media screen and (max-width: 1024px) {
          font-size: 6vw;
        }
        @media screen and (max-width: 800px) {
          font-size: 8vw;
        }
        &:hover {
          opacity: 1;
          position: relative;
          &:after {
            content: "";
            width: 30px;
            height: 30px;
            background: url(/static/img/flecha.svg);
            background-size: contain;
            position: absolute;
            left: -40px;
            top: 43%;
            background-repeat: no-repeat;
            @media screen and (max-width: 600px) {
           display: none;
          }
          }
          
        }
      }
    }
    &.open {
      transform: translateX(100vw);
      -webkit-transition: all 0.3s ease-out;
      transition: all 0.3s ease-out;
      z-index: -10;
      @media screen and (max-width: 1024px) {
        padding: 0 4vw 0 4vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/header.vue